(() => {
  const header = document.getElementById('HeaderWrapper');
  const headerSection = header && header.closest('.shopify-section-group-header-group');
  const bars = [];
  for (let section = headerSection && headerSection.nextElementSibling; section && section.classList.contains('shopify-section-group-header-group'); section = section.nextElementSibling) {
    if (section.matches('[id$="__announcement"], [id$="__scrolling_text_Bi3LVf"]')) bars.push(section);
  }
  function alignHeader() {
    if (!header || !header.classList.contains('header-wrapper--sticky') || !bars.length) return;
    const top = `${bars.reduce((height, bar) => height + bar.offsetHeight, 0)}px`;
    if (header.style.top !== top) header.style.top = top;
  }
  if (header && bars.length) {
    let headerFrame;
    const scheduleHeader = () => {
      cancelAnimationFrame(headerFrame);
      headerFrame = requestAnimationFrame(alignHeader);
    };
    new MutationObserver(scheduleHeader).observe(header, { attributes: true, attributeFilter: ['style'] });
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(scheduleHeader);
      bars.forEach((bar) => observer.observe(bar));
    }
    document.addEventListener('DOMContentLoaded', scheduleHeader);
    ['load', 'pageshow', 'resize'].forEach((event) => window.addEventListener(event, scheduleHeader));
    alignHeader();
  }
  const selector = '[data-syc-shipping-goal]';
  if (!document.querySelector(selector)) return;
  let timer;
  let pending = false;
  let rerun = false;
  function update(cart) {
    document.querySelectorAll(selector).forEach((goal) => {
      goal.hidden = cart.currency !== 'USD';
      if (goal.hidden) return;
      const total = Math.max(0, Number(cart.total_price) || 0);
      const remaining = Math.max(0, 10000 - total);
      const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: 'USD' }).format(remaining / 100);
      const message = remaining > 0 ? goal.dataset.remainingMessage.replace('[amount]', amount) : goal.dataset.qualifiedMessage;
      const text = goal.querySelector('.syc-shipping-goal__message');
      if (text.textContent.trim() !== message) text.textContent = message;
      goal.querySelector('progress').value = Math.min(100, total / 100);
    });
  }
  async function refresh() {
    if (pending) { rerun = true; return; }
    pending = true;
    try {
      const response = await fetch(window.theme.routes.cart, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' });
      if (response.ok) update(await response.json());
    } catch {} finally {
      pending = false;
      if (rerun) { rerun = false; schedule(); }
    }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 150); }
  ['cart:updated', 'cart:build', 'cart:open', 'ajaxProduct:added', 'shopify:section:load'].forEach((event) => document.addEventListener(event, schedule));
  ['CartDrawerForm', 'CartPageForm'].forEach((id) => {
    const form = document.getElementById(id);
    if (!form) return;
    new MutationObserver((changes) => {
      if (changes.some((change) => {
        const element = change.target.nodeType === 1 ? change.target : change.target.parentElement;
        return element && element.closest('[data-subtotal]');
      })) schedule();
    }).observe(form, { subtree: true, childList: true, characterData: true });
  });
  window.addEventListener('pageshow', schedule);
  schedule();
})();
